
import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";

import { promotionalTab } from 'utils/constants/default';
import PageLayout from 'layouts/PageLayout';
import { CustomTab } from 'components';
import BulkMail from './BulkMail';
import BulkNotification from './BulkNotification';

const Account: React.FC = () => {
    const { formatMessage } = useIntl();
    const [tab, setTab] = useState('email');

    return (
        <PageLayout title={formatMessage({ id : 'promotions'})} isList={false} hideToolbar>
            <CustomTab
                tabs={promotionalTab}
                onChange={(t) => setTab(t)}
                active={tab}
            />
            {tab == 'email' && <BulkMail/>}
            {tab == 'notification' && <BulkNotification/>}
        </PageLayout>
    )
}

export default Account;
